import React from 'react';
import { Form } from 'antd';
import { useQuery } from 'react-query';
import { getVoyages } from '@client/lib/api';
import Select from '@client/components/Select';

const InvoicesExport = () => {
	const {
		data: voyages,
	} = useQuery(
		['voyages'],
		() => getVoyages({
			disablePagination: true,
			includeCompleted: false
		}),
		{
			retry: false,
			keepPreviousData: true,
			refetchOnWindowFocus: false,
		},
	);

	return (
		<Form.Item name="contractIds" label="Contracts">
			<Select
				mode="multiple"
				placeholder="Select one or more types"
				allowClear
				options={[
					{
						label: 'All contracts',
						value: -1,
					},
					...(voyages?.rows ?? []).map((v) => ({
						label: v.identifier,
						value: v.id,
					})),
				]}
			/>
		</Form.Item>
	);
};

export default InvoicesExport;

